import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-70033f99"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "about" }
const _hoisted_2 = { id: "update" }
const _hoisted_3 = { id: "contact" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AboutMe = _resolveComponent("AboutMe")!
  const _component_UpdateNews = _resolveComponent("UpdateNews")!
  const _component_ContactInfo = _resolveComponent("ContactInfo")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("section", _hoisted_1, [
      _createVNode(_component_AboutMe)
    ]),
    _createElementVNode("section", _hoisted_2, [
      _createVNode(_component_UpdateNews)
    ]),
    _createElementVNode("section", _hoisted_3, [
      _createVNode(_component_ContactInfo)
    ])
  ], 64))
}